(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9fkOq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6bb5a8a5f5a6130a$export$71511d61b312f219; });
function $6bb5a8a5f5a6130a$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("aKPTH", function(module, exports) {

$parcel$export(module.exports, "Result", function () { return $be52c6202573c08c$export$8fdcabde73f49165; });
$parcel$export(module.exports, "AppState", function () { return $be52c6202573c08c$export$a0e153c73743701a; });
$parcel$export(module.exports, "ERT_MIMETYPE", function () { return $be52c6202573c08c$export$88ed3e818b57fc42; });
$parcel$export(module.exports, "DraggedItem", function () { return $be52c6202573c08c$export$d335428376330c3a; });
$parcel$export(module.exports, "entityId", function () { return $be52c6202573c08c$export$e43039b75c76ea; });
$parcel$export(module.exports, "unentityid", function () { return $be52c6202573c08c$export$6e3285c4fae95c89; });
$parcel$export(module.exports, "hideDialog", function () { return $be52c6202573c08c$export$94b8deb0ed09029; });
$parcel$export(module.exports, "showDialog", function () { return $be52c6202573c08c$export$61e0a65f251cfdb3; });
$parcel$export(module.exports, "setErrorCallback", function () { return $be52c6202573c08c$export$ddb93ae6240fef0f; });
$parcel$export(module.exports, "ErrorMessage", function () { return $be52c6202573c08c$export$915e9e7bd4f0f96d; });
$parcel$export(module.exports, "setDropHandler", function () { return $be52c6202573c08c$export$98aa5c0a5a0d090a; });
$parcel$export(module.exports, "formatDuration", function () { return $be52c6202573c08c$export$bc733b0c5cbb3e8a; });
$parcel$export(module.exports, "zeroPad", function () { return $be52c6202573c08c$export$3cdc770bf8b2ed3d; });
$parcel$export(module.exports, "formatDurationMsec", function () { return $be52c6202573c08c$export$857c3c538e52a274; });
$parcel$export(module.exports, "changeVolume", function () { return $be52c6202573c08c$export$af8f20e97b04879f; });
$parcel$export(module.exports, "getAppState", function () { return $be52c6202573c08c$export$4d01de599bd73c4a; });
$parcel$export(module.exports, "savePlaylist", function () { return $be52c6202573c08c$export$497987558c9d9d38; });
$parcel$export(module.exports, "showMkdirDlg", function () { return $be52c6202573c08c$export$891147337ca6b678; });
$parcel$export(module.exports, "showOrHidePlayerList", function () { return $be52c6202573c08c$export$ac1784466379fe3f; });

var $9fkOq = parcelRequire("9fkOq");

var $7opof = parcelRequire("7opof");

var $ccVOz = parcelRequire("ccVOz");

var $joRjU = parcelRequire("joRjU");

var $g9BBR = parcelRequire("g9BBR");

var $kwZQV = parcelRequire("kwZQV");
var $be52c6202573c08c$export$8fdcabde73f49165 = function Result(result) {
    "use strict";
    var status = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'ok';
    (0, $9fkOq._)(this, Result);
    this.result = result;
    this.status = status;
};
var $be52c6202573c08c$export$a0e153c73743701a = function AppState() {
    "use strict";
    (0, $9fkOq._)(this, AppState);
    this.capabilities = {};
};
var $be52c6202573c08c$export$88ed3e818b57fc42 = "application/x-ert-entities";
var $be52c6202573c08c$export$d335428376330c3a = function DraggedItem() {
    "use strict";
    (0, $9fkOq._)(this, DraggedItem);
};
function $be52c6202573c08c$export$e43039b75c76ea(type, id) {
    if (type == undefined) throw "entityId: missing type";
    if (id == undefined) throw "entityId: missing id";
    if (type == 'playlist') type = 'pl';
    var parts = id.toString().split(":");
    if (parts.length == 1 && !isNaN(parseInt(id.toString()))) // unqualified, numeric id -> prepend type
    return "".concat(type, "::").concat(id);
    // qualified id -> complain if the type doesn't match (and simply return the unmodified value otherwise)
    if (parts[0] != type) throw "entityId: type mismatch: type='".concat(type, "', id='").concat(id, "'");
    return id.toString();
}
function $be52c6202573c08c$export$6e3285c4fae95c89(qualifiedId) {
    if (!qualifiedId) throw "unentityid: missing id";
    var parts = qualifiedId.split('::');
    if (parts.length != 2) throw "unentityid: malformed id: ".concat(qualifiedId);
    var type = parts[0];
    var id = parseInt(parts[1]);
    return {
        'type': type,
        'id': id
    };
}
function $be52c6202573c08c$export$94b8deb0ed09029($elem) {
    if (typeof $elem == 'string') $elem = $($elem);
    var $modalContainer = $elem.parents('.modalContainer');
    $modalContainer.fadeOut(200);
}
function $be52c6202573c08c$export$61e0a65f251cfdb3(elem) {
    var $elem = $(elem);
    var $modalContainer = $elem.parents('.modalContainer');
    $modalContainer.find('> .modalContent').hide();
    $elem.show();
    $modalContainer.find('.cancel').off('click').on('click', function() {
        $be52c6202573c08c$export$94b8deb0ed09029($elem);
    });
    $modalContainer.fadeIn(200);
    return $elem;
}
var $be52c6202573c08c$var$_onErrorCallback = $be52c6202573c08c$var$_onErrorDefault;
function $be52c6202573c08c$var$_onErrorDefault(err, keepVisible) {
    var $popup = $('#errorMsg');
    if (err.msg != null) {
        if (console) console.log(err.msg);
        $popup.text(err.msg);
        $popup.show().css('opacity', 1);
        $popup.stop();
    } else $popup.hide();
    if (keepVisible !== true) $popup.show().delay(1000).animate({
        'opacity': 0
    }).hide(0);
}
function $be52c6202573c08c$export$ddb93ae6240fef0f(cb) {
    $be52c6202573c08c$var$_onErrorCallback = cb;
}
var $be52c6202573c08c$export$915e9e7bd4f0f96d = /*#__PURE__*/ function() {
    "use strict";
    function ErrorMessage(code, msg) {
        (0, $9fkOq._)(this, ErrorMessage);
        this.code = Number(code);
        this.msg = msg.toString();
        this.details = null;
    }
    (0, $7opof._)(ErrorMessage, [
        {
            key: "setDetails",
            value: function setDetails(details) {
                this.details = details;
                return this;
            }
        },
        {
            /// show message and fade out after 1sec (in the default implementation; override the way errors are displayed using setErrorCallback())
            key: "show",
            value: function show() {
                return this._show(false);
            }
        },
        {
            /// show message and keep visible (override the way errors are displayed using setErrorCallback())
            key: "showPersistent",
            value: function showPersistent() {
                return this._show(true);
            }
        },
        {
            key: "_show",
            value: function _show(keepVisible) {
                // todo make an onHttpError() for move in ajax error handlers and move the status code check there
                if (this.code == 401 || this.code == 403) {
                    $('body').addClass('loggedOut');
                    $be52c6202573c08c$export$61e0a65f251cfdb3('#loginDialog');
                    $('#loginUser').trigger('focus');
                    return;
                }
                return $be52c6202573c08c$var$_onErrorCallback(this, keepVisible);
            }
        }
    ]);
    return ErrorMessage;
}();
function $be52c6202573c08c$export$98aa5c0a5a0d090a($elem, fn) {
    $elem = $($elem); // TODO this line is backwards compatibility code - remove it once all callers are upgraded
    var canDrop = function canDrop() {
        return !$elem.data('nodrop');
    };
    $elem.on('dragenter', function(ev) {
        if (canDrop()) {
            //$elem.css('border-radius', '10px 10px');
            $elem.addClass('dropTarget');
            ev.preventDefault();
        }
    }).on('dragover', function(ev) {
        if (canDrop()) ev.preventDefault();
    }).on('dragleave', function(_ev) {
        $elem.removeClass('dropTarget');
    }).on('drop', function(ev) {
        if (canDrop()) {
            $elem.removeClass('dropTarget');
            fn(ev);
        }
    });
}
function $be52c6202573c08c$export$bc733b0c5cbb3e8a(secs, type) {
    if (secs == undefined || secs < 0 || type === 'stream') return '-:--';
    secs = Math.floor(secs);
    var mins = Math.floor(secs / 60);
    var ss = $be52c6202573c08c$export$3cdc770bf8b2ed3d(secs % 60, 2);
    var mm = mins.toString();
    if (mins >= 120) {
        var hours = Math.floor(mins / 60);
        mm = $be52c6202573c08c$export$3cdc770bf8b2ed3d(mins % 60, 2);
        return hours + "h" + (secs % 2 ? '.' : ' ') + mm + "m";
    } else return mm + ":" + ss;
}
function $be52c6202573c08c$export$857c3c538e52a274(msec, type) {
    if (msec == undefined || msec < 0 || type === 'stream') return '-:--';
    return $be52c6202573c08c$export$bc733b0c5cbb3e8a(msec / 1000);
}
function $be52c6202573c08c$export$af8f20e97b04879f(newVolume) {
    $ccVOz.post('/player/' + $kwZQV.getId() + '/volume', {
        "volume": newVolume
    }).then($kwZQV.gotStatus);
}
var $be52c6202573c08c$var$_appState = null;
var $be52c6202573c08c$var$_appStatePromise = null; // there should only be one request running at any time
function $be52c6202573c08c$export$4d01de599bd73c4a() {
    var reload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (reload || $be52c6202573c08c$var$_appState == null) {
        // decide if we need to (re)fetch the app state
        if ($be52c6202573c08c$var$_appStatePromise == null || reload) {
            $be52c6202573c08c$var$_appStatePromise = $.Deferred();
            $ccVOz.request('/player/state').then(function(data) {
                if (data.result.user == undefined) data.result.user = {};
                $be52c6202573c08c$var$_appStatePromise.resolve(data.result);
            }, function() {
                $be52c6202573c08c$var$_getLegacyAppState().then(function(rc) {
                    $be52c6202573c08c$var$_appStatePromise.resolve(rc);
                }, function(jqXHR, textStatus, errorThrown) {
                    $be52c6202573c08c$var$_appStatePromise.reject(jqXHR, textStatus, errorThrown);
                });
            });
        }
        $be52c6202573c08c$var$_appStatePromise.then(function(state) {
            $be52c6202573c08c$var$_appState = state;
            $('#archiveRoot').css({
                'display': state.capabilities.showMusicArchive ? '' : 'none'
            });
            $('#volumeCell').css({
                'display': state.capabilities.showPlayerVolume ? '' : 'none'
            });
            $('body').toggleClass('can-preview', state.capabilities.songPreviews === true);
            $('body').toggleClass('withSchedulerDates', state.capabilities.schedulerDates === true);
            // show scroll buttons if not explitly set to hide
            $('.scrollBtns').css('display', state.capabilities.showScrollButtons ? '' : 'none');
            $('body').toggleClass('withSettingsBtn', state.user.showSettingsButton === true);
        });
        return $be52c6202573c08c$var$_appStatePromise;
    } else return $.Deferred().resolve($be52c6202573c08c$var$_appState);
}
function $be52c6202573c08c$var$_getLegacyAppState() {
    // 2022-09-16: legacy code
    // for clients that lack the new /player/state endpoint we need to collect the data from different places.
    // this function does that and transforms the data we expect in AppState
    var promise = $.Deferred();
    var rc = new $be52c6202573c08c$export$a0e153c73743701a();
    var requests = $.when($ccVOz.request('/settings/state').then(function(data) {
        var result = data.result;
        if (result['archive.show']) rc.capabilities.showMusicArchive = true;
        if (result['scrollButtons.show']) rc.capabilities.showScrollButtons = true;
        if (result['search.instant']) rc.capabilities.instantSearch = true;
        if (result['volume.enabled']) rc.capabilities.showPlayerVolume = true;
        if (result['web.previews']) rc.capabilities.songPreviews = true;
    }), $ccVOz.request('player/list').then(function(data) {
        rc.players = data.result.players;
    }));
    requests.then(function() {
        promise.resolve(rc);
    }, function(jqXHR, textStatus, errorThrown) {
        promise.reject(jqXHR, textStatus, errorThrown);
    });
    return promise;
}
function $be52c6202573c08c$export$497987558c9d9d38() {
    var $dlg = $be52c6202573c08c$export$61e0a65f251cfdb3("#savePlDialog");
    var $nameInput = $('input', $dlg);
    var folderId = null; // null means parentDir=root
    function gotArchive(data) {
        var $ul = $('ul.plDir', $dlg).empty();
        $be52c6202573c08c$export$94b8deb0ed09029('#mkdirDialog'); // does nothing unless called as result of showMkdir()
        var userPlaylists = data.result.userPlaylists;
        if (userPlaylists == undefined) throw "missing userPlaylists";
        userPlaylists.name = "My Eartunes";
        userPlaylists.id = undefined; // have the parentId undefined if the users selects the root dir
        addDirsRec(userPlaylists, $ul, true).attr('data-tr', 'archive.userPlaylists');
        $nameInput.data('folderId', undefined);
        $g9BBR.set(undefined, $ul);
        $('#loadingAnim').hide();
    }
    $nameInput.val('').data('folderId', '');
    function addDirsRec(data, $ul, expanded) {
        if (data.type == undefined) throw "savePlaylist: missing archive entry type";
        var $li = $('<li>');
        var $titleDiv = $('<div>');
        $titleDiv.text(data.name || "ERROR").data('type', data.type);
        if (data.id !== undefined) $titleDiv.data('id', data.id);
        if (data.type == 'folder') $titleDiv.addClass('folder').on('click', function() {
            $('~ul', $titleDiv).toggleClass('hidden');
            $('.selected', $dlg).removeClass('selected');
            $titleDiv.addClass('selected');
            folderId = $titleDiv.data('id');
            $nameInput.data('folderId', $titleDiv.data('id'));
        });
        $li.append($titleDiv);
        if (data.children && data.children.length > 0) {
            var $subUl = $('<ul>');
            if (!expanded) $subUl.addClass('hidden');
            $li.append($subUl);
            for(var i = 0; i < data.children.length; i++)addDirsRec(data.children[i], $subUl, false);
        }
        $ul.append($li);
        return $titleDiv;
    }
    $('#loadingAnim').show();
    $joRjU.getArchive().then(gotArchive);
    var $savePlBtn = $dlg.find('.savePlBtn');
    $savePlBtn.off('click').on('click', function() {
        if (!$nameInput.val()) return;
        $('#loadingAnim').show();
        var data = {
            name: $nameInput.val(),
            folderId: undefined
        };
        var folderId = $nameInput.data('folderId');
        if (folderId !== null) data.folderId = folderId;
        $ccVOz.post('/player/' + $kwZQV.getId() + '/playlist/save?radio=true', data).then(function(data) {
            $joRjU.gotArchive(data);
            $('#loadingAnim').hide();
        });
        $nameInput.val('').data('folderId', '');
        $be52c6202573c08c$export$94b8deb0ed09029($dlg);
    });
    function checkPlName() {
        $savePlBtn.attr('disabled', $nameInput.val() ? null : 'disabled');
    }
    $nameInput.off('keyup').on('keyup', checkPlName);
    checkPlName();
    $('.mkdirBtn', $dlg).off('click').on('click', function() {
        $be52c6202573c08c$export$891147337ca6b678(folderId, gotArchive);
    });
}
function $be52c6202573c08c$export$ac1784466379fe3f(playerCount) {
    // add/remove the player selector (by setting the '.multiroom' class on the body element)
    if (playerCount > 1) $('body').addClass('multiroom');
    else $('body').removeClass('multiroom');
}
function $be52c6202573c08c$export$891147337ca6b678(parentId, gotArchive) {
    var $dlg = $be52c6202573c08c$export$61e0a65f251cfdb3('#mkdirDialog');
    $('input', $dlg).val('').trigger('focus');
    var $okBtn = $('.okBtn', $dlg);
    var $nameInput = $('.mkdirInput', $dlg);
    $okBtn.off('click').on('click', function() {
        var name = $nameInput.val();
        if (name.length == 0) return;
        var data = {
            "name": name,
            'parentId': null
        };
        if (parentId != null) data.parentId = parentId;
        $ccVOz.post('/archive/playlist/mkdir', data).then(gotArchive);
    });
    function checkName() {
        $okBtn.attr('disabled', $nameInput.val() ? null : 'disabled');
    }
    $nameInput.off('keyup').on('keyup', checkName);
    checkName();
}
function $be52c6202573c08c$export$3cdc770bf8b2ed3d(num, size) {
    var rc = num.toString();
    while(rc.length < size)rc = "0" + num;
    return rc;
}
$(function() {
    $g9BBR.set();
// disable right click
/*	$('body').bind('contextmenu', function(e) {
		e.preventDefault();
	});*/ });

});
parcelRegister("7opof", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $561e783bdb780511$export$71511d61b312f219; });
function $561e783bdb780511$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $561e783bdb780511$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $561e783bdb780511$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $561e783bdb780511$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("ccVOz", function(module, exports) {

$parcel$export(module.exports, "applyBaseURL", function () { return $868e2cad044bd671$export$3415acdabd03ae16; });
$parcel$export(module.exports, "post", function () { return $868e2cad044bd671$export$299ba2dee77727e9; });
$parcel$export(module.exports, "request", function () { return $868e2cad044bd671$export$b5fe3f66a567bec0; });
/**
 * wrapper around JQuery.ajax() that will re-queue requests if they failed with a HTTP 401 error (or in older players: 403)
 */ 
var $9fkOq = parcelRequire("9fkOq");

var $7opof = parcelRequire("7opof");

var $aKPTH = parcelRequire("aKPTH");
var $868e2cad044bd671$var$_requestsDisabled = false;
var $868e2cad044bd671$var$_requestQueue = [];
// Asynchronous API request
var $868e2cad044bd671$var$Request = /*#__PURE__*/ function() {
    "use strict";
    function Request(options) {
        (0, $9fkOq._)(this, Request);
        this.options = options;
        this.promise = $.Deferred();
    }
    (0, $7opof._)(Request, [
        {
            key: "run",
            value: function run() {
                var _this = this;
                if ($868e2cad044bd671$var$_requestsDisabled) {
                    // TODO we may not wanna queue POST requests...
                    $868e2cad044bd671$var$queueRequest(this);
                    return this;
                }
                // actually run the request (asynchronously, returning a promise)
                $.ajax(this.options).then(function(data, _textStatus, _jqXHR) {
                    _this.promise.resolve(data);
                }, function(jqXHR, textStatus, errorThrown) {
                    _this._onError(jqXHR, textStatus, errorThrown);
                });
                return this;
            }
        },
        {
            key: "_onError",
            value: function _onError(jqXHR, textStatus, errorThrown) {
                // 2022-08-17: new players use 401 for 'please login' and 403 for 'you're not allowed to do this'
                // older ones use 403 for both - TODO 2024-01-22: remove the 403 variant once we're certain everythings' been updated - etplayer.ErrorMessage() needs to be updated then aswell
                if (jqXHR.status == 401 || jqXHR.status == 403) {
                    // Auth error => re-queue the request
                    $868e2cad044bd671$var$queueRequest(this); // TODO we should not queue POST requests here
                    $868e2cad044bd671$var$_requestsDisabled = true;
                } else this.promise.reject(jqXHR, textStatus, errorThrown);
                new $aKPTH.ErrorMessage(jqXHR.status, "request failed: " + errorThrown).show();
            }
        },
        {
            //
            // selected promise methods
            //
            key: "done",
            value: function done(doneFilter) {
                this.promise.done(doneFilter);
                return this;
            }
        },
        {
            key: "then",
            value: function then(doneFilter, failFilter) {
                this.promise.then(doneFilter, failFilter);
                return this;
            }
        },
        {
            // helper that will call promise.fail() if this request fails
            key: "failOtherPromise",
            value: function failOtherPromise(promise) {
                this.promise.fail(function(jqXHR, textStatus, errorThrown) {
                    promise.reject(jqXHR, textStatus, errorThrown);
                });
                return this;
            }
        }
    ]);
    return Request;
}();
// triggered by #loginForm's onsubmit
function $868e2cad044bd671$var$login(ev) {
    var $userInput = $('#loginUser');
    var $pwdInput = $('#loginPwd');
    var user = $userInput.val();
    var pwd = $pwdInput.val();
    $userInput.val('');
    $pwdInput.val('');
    $.ajax({
        url: $868e2cad044bd671$export$3415acdabd03ae16('/login'),
        method: 'POST',
        data: {
            'user': user,
            'pwd': pwd
        }
    }).done(function(_data) {
        $aKPTH.hideDialog('#loginDialog');
        $('#loginErr').hide();
        $868e2cad044bd671$var$_requestsDisabled = false;
        $('body').removeClass('loggedOut');
        while($868e2cad044bd671$var$_requestQueue.length > 0){
            var req = $868e2cad044bd671$var$_requestQueue.pop();
            if (!req) throw "request queue empty!?!";
            req.run();
        }
    }).fail(function(_jqXHR, _textStatus, _errorThrown) {
        $('#loginErr').show();
    });
    ev.preventDefault();
}
function $868e2cad044bd671$export$299ba2dee77727e9(url, data, options) {
    if (!options) options = {};
    options.url = $868e2cad044bd671$export$3415acdabd03ae16(url);
    options.dataType = 'json';
    options.data = data;
    options.method = "POST";
    var rc = new $868e2cad044bd671$var$Request(options);
    return rc.run();
}
// adds a request to the queue (will be executed once the user logs in); returns a promise
function $868e2cad044bd671$var$queueRequest(req) {
    if (req.options.url == undefined) throw "missing request URL";
    if (req.options.url.match(/player\/[0-9]+\/info/)) {
        //console.log("Not queueing info request: "+data.url);
        req.promise.reject(undefined, "not logged in", null); //return a rejected promise (i.e. fail() callbacks will be called immediately)
        return;
    }
    $868e2cad044bd671$var$_requestQueue.push(req);
}
function $868e2cad044bd671$export$b5fe3f66a567bec0(url, data, options) {
    if (!options) options = {};
    options.url = $868e2cad044bd671$export$3415acdabd03ae16(url);
    options.dataType = 'json';
    options.data = data;
    var rc = new $868e2cad044bd671$var$Request(options);
    return rc.run();
}
// base URL for API requests (see applyBaseURL())
var $868e2cad044bd671$var$_baseURL = undefined;
function $868e2cad044bd671$export$3415acdabd03ae16(url) {
    if ($868e2cad044bd671$var$_baseURL === undefined) {
        var pattern = /^(\/?[^\/]+\/[^\/]+).*$/g;
        // first time initialization
        // take the first two path segments and prepend them to all future API requests
        if (document.location.pathname.match(pattern)) $868e2cad044bd671$var$_baseURL = document.location.pathname.replace(pattern, '$1');
        else $868e2cad044bd671$var$_baseURL = null;
    }
    if ($868e2cad044bd671$var$_baseURL === null) return url;
    if (!url.startsWith('/')) url = '/' + url;
    var rc = new URL(url, document.location.toString());
    rc.pathname = $868e2cad044bd671$var$_baseURL.replace(/\/+$/, '') + '/' + rc.pathname.replace(/^\/+/, '');
    return rc.toString();
}
$(function() {
    $('#loginForm').on('submit', $868e2cad044bd671$var$login);
});

});

parcelRegister("joRjU", function(module, exports) {

$parcel$export(module.exports, "ArchiveData", function () { return $5de7dc6f2fa238d6$export$6729688299ca71e5; });
$parcel$export(module.exports, "Entry", function () { return $5de7dc6f2fa238d6$export$3bb977b3ba9d3b59; });
$parcel$export(module.exports, "reloadWidget", function () { return $5de7dc6f2fa238d6$export$7cf11d061990747e; });
$parcel$export(module.exports, "getArchive", function () { return $5de7dc6f2fa238d6$export$e53e9d9e76de0272; });
$parcel$export(module.exports, "gotArchive", function () { return $5de7dc6f2fa238d6$export$c47b854930d0a8b1; });
$parcel$export(module.exports, "deleteSelectedPlaylist", function () { return $5de7dc6f2fa238d6$export$2f033f05e0e665c7; });
$parcel$export(module.exports, "deleteUserFolder", function () { return $5de7dc6f2fa238d6$export$fa4c57157a01eafa; });
$parcel$export(module.exports, "deleteUserPlaylist", function () { return $5de7dc6f2fa238d6$export$346bfbf229cc570a; });
$parcel$export(module.exports, "fetchSongInfo", function () { return $5de7dc6f2fa238d6$export$6b71230c260da70f; });
$parcel$export(module.exports, "getJingles", function () { return $5de7dc6f2fa238d6$export$3266e2430b908b61; });
$parcel$export(module.exports, "loadCurrent", function () { return $5de7dc6f2fa238d6$export$efcb51714e398584; });
$parcel$export(module.exports, "scrollPage", function () { return $5de7dc6f2fa238d6$export$f412f9532b81b772; });
$parcel$export(module.exports, "scrollTo", function () { return $5de7dc6f2fa238d6$export$3f99968195accfaf; });
$parcel$export(module.exports, "showPlaylists", function () { return $5de7dc6f2fa238d6$export$1482f8ee080ec40f; });

var $9fkOq = parcelRequire("9fkOq");

var $7opof = parcelRequire("7opof");

var $aKPTH = parcelRequire("aKPTH");

var $ccVOz = parcelRequire("ccVOz");

var $jM90n = parcelRequire("jM90n");

var $g9BBR = parcelRequire("g9BBR");

var $kwZQV = parcelRequire("kwZQV");
var $5de7dc6f2fa238d6$export$6729688299ca71e5 = function ArchiveData() {
    "use strict";
    (0, $9fkOq._)(this, ArchiveData);
};
var $5de7dc6f2fa238d6$var$JinglesData = function JinglesData() {
    "use strict";
    (0, $9fkOq._)(this, JinglesData);
};
var $5de7dc6f2fa238d6$export$3bb977b3ba9d3b59 = function Entry() {
    "use strict";
    (0, $9fkOq._)(this, Entry);
};
var $5de7dc6f2fa238d6$var$SongInfo = function SongInfo() {
    "use strict";
    (0, $9fkOq._)(this, SongInfo);
};
function $5de7dc6f2fa238d6$export$7cf11d061990747e() {
    return $5de7dc6f2fa238d6$export$e53e9d9e76de0272().then(function(data) {
        $5de7dc6f2fa238d6$export$c47b854930d0a8b1(data);
    });
}
var $5de7dc6f2fa238d6$var$TreeItem = /*#__PURE__*/ function() {
    "use strict";
    function TreeItem(parent, entity) {
        (0, $9fkOq._)(this, TreeItem);
        this.li = $("<li>");
        this.titleDiv = $("<div>").addClass('title clickable');
        this.submenuUl = null;
        this.parent = null;
        this.children = [];
        this.isExpanded = false;
        this.parent = parent;
        this.entity = entity;
        if (entity.mutable === true) $aKPTH.setDropHandler(this.titleDiv, $5de7dc6f2fa238d6$var$dropItem);
        if (entity.type == "folder") this.titleDiv.addClass('folder');
        if (entity.type == "stream") this.titleDiv.addClass('stream');
        this.titleDiv.data('treeItem', this);
    }
    (0, $7opof._)(TreeItem, [
        {
            key: "getEntityId",
            value: function getEntityId() {
                return $aKPTH.entityId(this.entity.type, this.entity.id);
            }
        },
        {
            key: "isDeletable",
            value: function isDeletable() {
                return this.titleDiv.hasClass('deletable');
            }
        },
        {
            // expand/collapse (or toggle) a TreeItem
            key: "expand",
            value: function expand(newValue) {
                if (newValue == undefined) newValue = !this.isExpanded;
                this.isExpanded = newValue;
                if (!newValue && this.entity.type == 'folder') this.li.addClass("collapsed");
                else this.li.removeClass("collapsed");
                if (newValue && this.parent != null) this.parent.expand(newValue);
            }
        },
        {
            key: "getPath",
            value: function getPath() {
                var rc = [];
                var item = this;
                while(item != null){
                    rc.unshift(item.titleDiv.text());
                    item = item.parent;
                }
                return rc;
            }
        },
        {
            key: "markNew",
            value: function markNew() {
                if (this.parent == null) return; // root TreeItems won't be marked as new
                this.titleDiv.addClass('new');
                this.parent.markNew();
            }
        }
    ]);
    return TreeItem;
}();
var $5de7dc6f2fa238d6$var$ArchiveTree = /*#__PURE__*/ function() {
    "use strict";
    function ArchiveTree(archiveUl) {
        (0, $9fkOq._)(this, ArchiveTree);
        this.treeItems = {};
        this.rootItems = [];
        this.selectedItem = null;
        this.archiveUl = archiveUl;
        archiveUl.data('archiveTree', this);
    }
    (0, $7opof._)(ArchiveTree, [
        {
            key: "addFolder",
            value: function addFolder(obj, expanded, title, classes) {
                var rc = this._addFolderRec(null, obj, expanded, title, classes);
                this.rootItems.push(rc);
                this.archiveUl.append(rc.li);
                return rc;
            }
        },
        {
            key: "_addFolderRec",
            value: function _addFolderRec(parent, obj, expanded, title, classes) {
                var rc = new $5de7dc6f2fa238d6$var$TreeItem(parent, obj);
                var entityId = $aKPTH.entityId(obj.type, obj.id);
                var text = obj.name ? obj.name : 'ERROR';
                if (title != undefined) text = title;
                else if (text === undefined) text = obj.title ? obj.title : 'ERROR';
                rc.titleDiv.text(text);
                rc.titleDiv.data('type', obj.type || null);
                if (obj.id !== undefined) rc.titleDiv.data('id', obj.id);
                // make items draggable
                rc.titleDiv.attr("draggable", "true").on('dragstart', $5de7dc6f2fa238d6$var$dragItem);
                if (classes !== undefined) rc.titleDiv.addClass(classes);
                rc.li.append(rc.titleDiv);
                parent === null || parent === void 0 ? void 0 : parent.submenuUl.append(rc.li);
                if (obj.children && obj.children.length > 0) {
                    rc.submenuUl = $("<ul>");
                    //$ul.attr('id', $titleDiv.attr('id')+"_submenu");
                    rc.li.append(rc.submenuUl);
                    for(var i in obj.children){
                        var childObj = obj.children[i];
                        var childItem = this._addFolderRec(rc, childObj, false, undefined, classes);
                        rc.children.push(childItem);
                    }
                }
                rc.titleDiv.on('click', $5de7dc6f2fa238d6$var$itemClicked);
                rc.expand(expanded);
                // mark new playlists (and their parent directories)
                if (obj.new === true) rc.markNew();
                if (this.treeItems[entityId]) console.error("duplicate entityId in ArchiveTree: ", entityId);
                this.treeItems[entityId] = rc;
                return rc;
            }
        },
        {
            key: "getTreeItem",
            value: function getTreeItem(entityId) {
                return this.treeItems[entityId];
            }
        },
        {
            key: "listExpandedItems",
            value: function listExpandedItems() {
                var rc = {};
                for(var entityId in this.treeItems){
                    var treeItem = this.treeItems[entityId];
                    if (treeItem.isExpanded) rc[entityId] = treeItem;
                }
                return rc;
            }
        },
        {
            key: "selectItem",
            value: function selectItem(treeItem, scroll) {
                this.selectedItem = treeItem;
                var $archive = $('#archive');
                $jM90n.selectionChanged($archive, treeItem.titleDiv);
                $jM90n.songlist.load(treeItem.entity.type, treeItem.entity.id, treeItem.isDeletable());
                treeItem.expand(); // toggle
                if (scroll === true) {
                    treeItem.expand(true); // expand (recursively))
                    // scroll to item
                    var offset = treeItem.titleDiv.offset(), scrollTop = $archive.scrollTop();
                    if (offset == undefined || scrollTop == undefined) throw "modArchive.selectItem: missing element position";
                    $archive.animate({
                        scrollTop: offset.top - $archive.offset().top + scrollTop
                    }, 300);
                }
                // enable/disable dropping songs on the songlist
                if (treeItem.entity.mutable === true) $('#songlist').removeData('nodrop');
                else $('#songlist').data('nodrop', true);
            }
        }
    ], [
        {
            key: "get",
            value: function get(archiveUl) {
                return archiveUl.data('archiveTree');
            }
        }
    ]);
    return ArchiveTree;
}();
function $5de7dc6f2fa238d6$export$2f033f05e0e665c7() {
    var archive = $5de7dc6f2fa238d6$var$ArchiveTree.get($('#archive'));
    var selectedItem = archive.selectedItem;
    var action;
    var postData;
    var $dlg;
    if (selectedItem == null) return;
    var selectedEntity = selectedItem.entity;
    if (selectedEntity.type == 'playlist') {
        action = 'delete';
        postData = {
            'plId': selectedEntity.id
        };
        $dlg = $aKPTH.showDialog('#deletePlDialog');
    } else if (selectedEntity.type == 'folder') {
        action = 'rmdir';
        postData = {
            'folderId': selectedEntity.id
        };
        $dlg = $aKPTH.showDialog('#deleteFolderDialog');
    }
    if (!action || !$dlg) throw "can't delete " + selectedEntity.type;
    var $pathUl = $('.path', $dlg).empty();
    var selectedPath = selectedItem.getPath();
    for(var i = 1; i < selectedPath.length; i++)$pathUl.append($('<li>').text(selectedPath[i]));
    $('.btnDelete', $dlg).off('click').on('click', function() {
        $('#loadingAnim').show();
        $5de7dc6f2fa238d6$var$_deleteThing(action, postData).then(function(data) {
            $aKPTH.hideDialog('#deletePlDialog');
            $('#loadingAnim').hide();
        });
    });
}
function $5de7dc6f2fa238d6$export$fa4c57157a01eafa(folderId) {
    return $5de7dc6f2fa238d6$var$_deleteThing('rmdir', {
        'folderId': folderId
    });
}
function $5de7dc6f2fa238d6$export$346bfbf229cc570a(plId) {
    return $5de7dc6f2fa238d6$var$_deleteThing('delete', {
        'plId': plId
    });
}
function $5de7dc6f2fa238d6$var$_deleteThing(action, postData) {
    var rc = $ccVOz.post("archive/playlist/" + action + "?radio=true", postData);
    rc.then(function(data) {
        $5de7dc6f2fa238d6$export$c47b854930d0a8b1(data);
        $('#loadingAnim').hide();
    });
    return rc;
}
function $5de7dc6f2fa238d6$var$dragItem(ev) {
    var _ev_originalEvent;
    var dataTransfer = (_ev_originalEvent = ev.originalEvent) === null || _ev_originalEvent === void 0 ? void 0 : _ev_originalEvent.dataTransfer;
    if (!dataTransfer) throw "archive.dragItem: missing dataTransfer";
    var $elem = $(ev.target);
    var data = [
        {
            type: $elem.data('type'),
            id: $elem.data('id')
        }
    ];
    dataTransfer.setData($aKPTH.ERT_MIMETYPE, JSON.stringify(data));
}
function $5de7dc6f2fa238d6$var$dropItem(ev) {
    var _ev_originalEvent;
    var dataTransfer = (_ev_originalEvent = ev.originalEvent) === null || _ev_originalEvent === void 0 ? void 0 : _ev_originalEvent.dataTransfer;
    if (!dataTransfer) throw "archive.dropItem: missing dataTransfer";
    var $elem = $(ev.target);
    var plId = $elem.data('id');
    var data = JSON.parse(dataTransfer.getData($aKPTH.ERT_MIMETYPE));
    if ($elem.data('type') != 'playlist') throw "can't drop on non-playlists!";
    console.log("drop:", data);
    $ccVOz.request("/archive/playlist/add?plId=" + plId, JSON.stringify(data), {
        method: 'POST',
        contentType: "application/json"
    }).then(function(_data) {
    // we're dropping into an invisible playlist here -> don't reload playlistWidget
    //modList.playlist.loadData(data);
    });
}
function $5de7dc6f2fa238d6$export$6b71230c260da70f(id) {
    var rc = $.Deferred();
    $ccVOz.request('/archive/song/' + id).then(function(data) {
        rc.resolve(data.result);
    }).failOtherPromise(rc);
    return rc;
}
function $5de7dc6f2fa238d6$var$itemClicked(ev) {
    var treeItem = $(ev.target).data('treeItem');
    if (treeItem == null) return;
    $5de7dc6f2fa238d6$var$ArchiveTree.get($("#archive")).selectItem(treeItem);
    ev.stopPropagation();
}
function $5de7dc6f2fa238d6$export$e53e9d9e76de0272() {
    var reload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var rc = $.Deferred();
    if (reload || $5de7dc6f2fa238d6$export$e53e9d9e76de0272._archive === null) $ccVOz.request('/archive?radio=true').then(function(data) {
        rc.resolve(data);
    }).failOtherPromise(rc);
    else rc.resolve($5de7dc6f2fa238d6$export$e53e9d9e76de0272._archive);
    return rc;
}
$5de7dc6f2fa238d6$export$e53e9d9e76de0272._archive = null;
function $5de7dc6f2fa238d6$export$3266e2430b908b61() {
    var reload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var rc = $.Deferred();
    if (reload || $5de7dc6f2fa238d6$export$3266e2430b908b61._jingles === null) $ccVOz.request('/archive/jingles').then(function(data) {
        rc.resolve(data);
    }).failOtherPromise(rc);
    else rc.resolve($5de7dc6f2fa238d6$export$3266e2430b908b61._jingles);
    return rc;
}
$5de7dc6f2fa238d6$export$3266e2430b908b61._jingles = null;
function $5de7dc6f2fa238d6$export$c47b854930d0a8b1(data) {
    var _archive_selectedItem;
    if (data.result == undefined) return;
    // save expanded+selected folders
    var archive = $5de7dc6f2fa238d6$var$ArchiveTree.get($("#archive"));
    var expandedItems = (archive === null || archive === void 0 ? void 0 : archive.listExpandedItems()) || {};
    var selectedId = archive === null || archive === void 0 ? void 0 : (_archive_selectedItem = archive.selectedItem) === null || _archive_selectedItem === void 0 ? void 0 : _archive_selectedItem.getEntityId();
    // reload data
    var archive = new $5de7dc6f2fa238d6$var$ArchiveTree($('#archive').empty());
    if (data.result.playlists !== undefined) archive.addFolder(data.result.playlists, true, "Eartunes").titleDiv.attr('data-tr', 'archive.playlists');
    if (data.result.userPlaylists !== undefined) archive.addFolder(data.result.userPlaylists, true, "My Eartunes", 'deletable').titleDiv.attr('data-tr', 'archive.userPlaylists').removeClass('deletable');
    if (data.result.radio !== undefined) archive.addFolder(data.result.radio, true, "Eartunes Radio").titleDiv.attr('data-tr', 'archive.radio');
    if (data.result.folders !== undefined) archive.addFolder(data.result.folders, false, "Music Archive").titleDiv.attr('data-tr', 'archive.archive').parent().attr('id', 'archiveRoot');
    $aKPTH.getAppState().then(function(appState) {
        if (!appState.capabilities.showMusicArchive) $('#archiveRoot').css({
            'display': 'none'
        });
    });
    $g9BBR.set(undefined, archive.archiveUl);
    // re-expand folders
    for(var entityId in archive.treeItems){
        if (!expandedItems[entityId]) continue;
        var treeItem = archive.treeItems[entityId];
        treeItem.expand(true);
    }
    if (selectedId != null) {
        var selectedItem = archive.getTreeItem(selectedId);
        if ($5de7dc6f2fa238d6$var$TreeItem != null) archive.selectItem(selectedItem);
    }
}
function $5de7dc6f2fa238d6$export$efcb51714e398584(append) {
    var cmd = "load";
    if (append) cmd = "append";
    $('#archive .selected').each(function() {
        var data = {
            type: $(this).data('type'),
            id: $(this).data('id')
        };
        $jM90n.playlist.showLoadingIndicator();
        $ccVOz.post("/player/" + $kwZQV.getId() + "/playlist/" + cmd, data).then(function(data) {
            $jM90n.playlist.loadData(data);
        });
        cmd = 'append'; // if more than one were selected, append all but the first
    });
    $('body').removeClass('showOverlay');
}
function $5de7dc6f2fa238d6$export$f412f9532b81b772(direction) {
    var $archive = $('#archive');
    var scrollTop = $archive.scrollTop();
    var height = $archive.height();
    if (scrollTop == undefined || height == undefined) throw "modArchive.scrollPage(): undefined height and/or scrollTop";
    var tgtPos = scrollTop + height * direction; // scroll a whole page
    $5de7dc6f2fa238d6$export$3f99968195accfaf(tgtPos);
}
function $5de7dc6f2fa238d6$export$3f99968195accfaf(pos) {
    var $archive = $('#archive');
    var scrollTop = $archive.scrollTop();
    var height = $archive.height();
    if (scrollTop == undefined || height == undefined) throw "modArchive.scrollTo(): undefined height and/or scrollTop";
    if (Math.abs(scrollTop - pos) <= height + 100) // animate scroll if it's not too far
    $archive.stop().animate({
        scrollTop: pos
    }, 250);
    else $archive.stop().scrollTop(pos);
}
function $5de7dc6f2fa238d6$var$selectEntity(entityId, scroll) {
    var archiveTree = $5de7dc6f2fa238d6$var$ArchiveTree.get($('#archive'));
    var treeItem = archiveTree.getTreeItem(entityId);
    if (treeItem == null) return;
    console.log("selecting entity: ", treeItem.getPath());
    archiveTree.selectItem(treeItem, scroll);
}
function $5de7dc6f2fa238d6$export$1482f8ee080ec40f(pls) {
    var $ul = $('#songPlaylists ul');
    $ul.empty();
    for(var plId in pls){
        var name = pls[plId];
        //		console.log('pl: ', plId, " - ", name);
        var li = document.createElement('li');
        var div = document.createElement('div');
        div.dataset['type'] = 'playlist';
        div.dataset['id'] = plId;
        div.className = 'title clickable';
        $(div).text(name).on('click', function(_ev) {
            console.log('pl clicked: ', this.dataset);
            var type = this.dataset['type'], id = this.dataset['id'];
            if (type == undefined || id == undefined) throw "showPlaylists: missing id/type";
            $5de7dc6f2fa238d6$var$selectEntity($aKPTH.entityId(type, id), true);
        });
        li.appendChild(div);
        $ul.append(li);
    }
    $('#songPlaylists').removeClass('hidden');
}

});
parcelRegister("jM90n", function(module, exports) {

$parcel$export(module.exports, "selectionChanged", function () { return $b7e1373c359c4425$export$6abf7ade54df8039; });
$parcel$export(module.exports, "playlist", function () { return $b7e1373c359c4425$export$5c987fb934dae1e6; });
$parcel$export(module.exports, "dropOnSonglist", function () { return $b7e1373c359c4425$export$81b10555f70f380f; });
$parcel$export(module.exports, "songlist", function () { return $b7e1373c359c4425$export$98b7ee2ca8db699; });
$parcel$export(module.exports, "dropOnPlaylist", function () { return $b7e1373c359c4425$export$6f3980afc4059bcb; });

var $9fkOq = parcelRequire("9fkOq");

var $7opof = parcelRequire("7opof");

var $aKPTH = parcelRequire("aKPTH");

var $ccVOz = parcelRequire("ccVOz");

var $joRjU = parcelRequire("joRjU");

var $kwZQV = parcelRequire("kwZQV");
var $b7e1373c359c4425$var$ListData = function ListData() {
    "use strict";
    (0, $9fkOq._)(this, ListData);
};
var $b7e1373c359c4425$var$ListItem = function ListItem() {
    "use strict";
    (0, $9fkOq._)(this, ListItem);
};
var $b7e1373c359c4425$var$ListWidget = /*#__PURE__*/ function() {
    "use strict";
    function ListWidget($listUl, type) {
        (0, $9fkOq._)(this, ListWidget);
        this.$listUl = $listUl;
        this.type = type;
    }
    (0, $7opof._)(ListWidget, [
        {
            key: "deleteSelected",
            value: function deleteSelected() {
                var wgt = this;
                $('.selected', this.$listUl).each(function(_idx, item) {
                    var selDs = item.dataset;
                    var postData = {
                        'id': selDs['id'],
                        'type': selDs['type'],
                        'plId': undefined
                    };
                    if (wgt.type == 'songlist') {
                        if (wgt.$listUl.data('type') == 'playlist') {
                            postData['plId'] = wgt.$listUl.data('id');
                            wgt.showLoadingIndicator();
                            $ccVOz.post('/archive/playlist/delete/song', postData).then(function(data) {
                                wgt.loadData(data, true);
                            });
                        }
                    } else if (wgt.type == 'playlist') {
                        wgt.showLoadingIndicator();
                        $ccVOz.post('/player/' + $kwZQV.getId() + '/playlist/deleteItem', postData).then(function(data) {
                            wgt.loadData(data, true);
                        });
                    }
                });
            }
        },
        {
            // finds the requested entity in the list
            key: "findRow",
            value: function findRow(type, id) {
                var rowIDs = this.$listUl.data('rowIDs') || {};
                return rowIDs[$aKPTH.entityId(type, id)];
            }
        },
        {
            key: "load",
            value: function load(type, id, deletable) {
                var _this = this;
                this.$listUl.data('id', id);
                this.$listUl.data('type', type);
                this.showLoadingIndicator();
                $ccVOz.request('archive/' + type + '/' + id).then(function(data) {
                    _this.loadData(data, deletable);
                });
            }
        },
        {
            key: "loadData",
            value: function loadData(data) {
                var _this = this;
                var deletable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (data && data.result != undefined && data.result.items) {
                    var items = data.result.items;
                    this.$listUl.empty();
                    var cellNames = [
                        'title',
                        'artist',
                        'duration'
                    ];
                    var rowIDs = this.$listUl.data('rowIDs');
                    if (rowIDs === undefined) {
                        rowIDs = {};
                        this.$listUl.data('rowIDs', rowIDs);
                    }
                    for(var i in items){
                        var item = items[i];
                        if (item.id == undefined) throw "unexpected: missing entity id";
                        if (item.type == undefined) throw "unexpected: missing entity type";
                        var $row = $('<div class="listRow clickable" draggable="true">');
                        $row.on('dragstart', $b7e1373c359c4425$var$dragItem);
                        if (deletable === true || this.type == 'playlist') $row.addClass('deletable');
                        var cells = [
                            item.title,
                            item.artist,
                            $aKPTH.formatDuration(item.duration, item.type)
                        ];
                        for(var j in cells){
                            var $div = $('<div>');
                            $div.text(cells[j] || "").addClass(cellNames[j] + 'Col');
                            //var div = document.createTextNode(cells[j]);
                            $row.append($div);
                        }
                        $row.attr('data-id', item.id);
                        $row.attr('data-type', item.type);
                        rowIDs[$aKPTH.entityId(item.type, item.id)] = $row[0];
                        $row.on('click', function(ev) {
                            var toggle = ev.metaKey || ev.ctrlKey;
                            $b7e1373c359c4425$export$6abf7ade54df8039(_this.$listUl, $(ev.currentTarget), toggle);
                        });
                        this.$listUl.append($row);
                    }
                    $('#' + this.type + 'Duration').text($b7e1373c359c4425$var$formatListDuration(data.result.duration));
                    if (data.result.hash != undefined) this.$listUl.data('_hash', data.result.hash);
                    var entities = data.result.entities;
                    if (!entities) entities = '';
                    $('#' + this.type + 'Lists').text(entities);
                }
                var $wrapper = this.$listUl.parent().removeClass("loading");
                $('.loadingIndicator', $wrapper).stop().fadeOut(100);
            }
        },
        {
            // 'play' or 'enqueue' the selected list items
            key: "playSelected",
            value: function playSelected(mode) {
                if (({
                    'play': 0,
                    'enqueue': 0
                })[mode] === undefined) throw "playSelected: unsupported mode: " + mode;
                // TODO do this in a single request (instead of one per selected item)
                var postData = [];
                $('.selected', this.$listUl).each(function(_idx, item) {
                    var id = item.dataset['id'];
                    var type = item.dataset['type'];
                    if (id == undefined || type == undefined) throw "unexpected: selected item lacks id and/or type";
                    postData.push({
                        id: parseInt(id),
                        type: type
                    });
                });
                // call play/enqueue for each item
                var cb = function cb(items, mode) {
                    // TODO this doesn't loop over the whole postData list!
                    if (items.length == 0) return;
                    $b7e1373c359c4425$export$5c987fb934dae1e6.showLoadingIndicator();
                    $ccVOz.post("/player/" + $kwZQV.getId() + "/" + mode, items.shift()).then(function(data) {
                        $b7e1373c359c4425$export$5c987fb934dae1e6.loadData(data);
                    });
                    // everything but the first item will be enqueued
                    if (mode == 'play') mode = 'enqueue';
                    cb(items, mode);
                };
                cb(postData, mode);
            }
        },
        {
            // scrolls down by 'direction * height'
            key: "scrollPage",
            value: function scrollPage(direction) {
                var scrollTop = this.$listUl.scrollTop();
                var height = this.$listUl.height();
                if (scrollTop == undefined || height == undefined) throw this.type + ".scrollPage(): undefined height and/or scrollTop";
                var tgtPos = scrollTop + height * direction; // scroll a whole page
                this.scrollTo(tgtPos);
            }
        },
        {
            key: "scrollTo",
            value: function scrollTo(pos) {
                var scrollTop = this.$listUl.scrollTop();
                var height = this.$listUl.height();
                if (scrollTop == undefined || height == undefined) throw this.type + ".scrollTo(): undefined height and/or scrollTop";
                if (Math.abs(scrollTop - pos) <= height + 100) // animate scroll if it's not too far
                this.$listUl.stop().animate({
                    scrollTop: pos
                }, 250);
                else this.$listUl.stop().scrollTop(pos);
            }
        },
        {
            key: "showLoadingIndicator",
            value: function showLoadingIndicator() {
                var $wrapper = this.$listUl.parent();
                $('.loadingIndicator', $wrapper).stop().fadeIn(300);
            }
        }
    ]);
    return ListWidget;
}();
function $b7e1373c359c4425$var$dragItem(ev) {
    var _ev_originalEvent;
    var dataTransfer = (_ev_originalEvent = ev.originalEvent) === null || _ev_originalEvent === void 0 ? void 0 : _ev_originalEvent.dataTransfer;
    var data = ev.target.dataset;
    if (dataTransfer == null) throw "modList.dragItem: null dataTransfer";
    dataTransfer.setData($aKPTH.ERT_MIMETYPE, JSON.stringify([
        {
            type: data.type,
            id: data.id
        }
    ]));
}
function $b7e1373c359c4425$export$81b10555f70f380f(ev) {
    var _ev_originalEvent;
    var dataTransfer = (_ev_originalEvent = ev.originalEvent) === null || _ev_originalEvent === void 0 ? void 0 : _ev_originalEvent.dataTransfer;
    var $songlist = $('#songlist');
    var plId = $songlist.data('id');
    if (dataTransfer == undefined) throw "dropOnSonglist: missing dataTransfer";
    var data = JSON.parse(dataTransfer.getData($aKPTH.ERT_MIMETYPE));
    if ($songlist.data('type') != 'playlist') throw "can only drop on user playlists!";
    console.log("drop:");
    $b7e1373c359c4425$export$98b7ee2ca8db699.showLoadingIndicator();
    $ccVOz.request("/archive/playlist/add?plId=" + plId, JSON.stringify(data), {
        method: 'POST',
        contentType: "application/json"
    }).then(function(data) {
        $b7e1373c359c4425$export$98b7ee2ca8db699.loadData(data);
    });
}
function $b7e1373c359c4425$export$6f3980afc4059bcb(ev) {
    var _ev_originalEvent;
    var dataTransfer = (_ev_originalEvent = ev.originalEvent) === null || _ev_originalEvent === void 0 ? void 0 : _ev_originalEvent.dataTransfer;
    if (dataTransfer == undefined) throw "dropOnPlaylist: missing dataTransfer";
    var data = JSON.parse(dataTransfer.getData($aKPTH.ERT_MIMETYPE));
    if (data.length != 1) throw "drop data has to be a list of length 1";
    var reqData = data[0];
    $b7e1373c359c4425$export$5c987fb934dae1e6.showLoadingIndicator();
    $ccVOz.post("/player/" + $kwZQV.getId() + "/playlist/append", reqData).then(function(data) {
        $b7e1373c359c4425$export$5c987fb934dae1e6.loadData(data);
    });
}
function $b7e1373c359c4425$var$formatListDuration(sec) {
    if (sec == undefined) return "--";
    var rc = [];
    if (sec > 3600) {
        rc.push(Math.floor(sec / 3600) + 'h');
        sec %= 3600;
    }
    rc.push(Math.floor(sec / 60) + 'm');
    rc.push(Math.floor(sec % 60) + 's');
    return rc.join(' ');
}
function $b7e1373c359c4425$export$6abf7ade54df8039($list, $item) {
    var toggle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!toggle) $('.selected', $list).removeClass("selected");
    // show/hide the delete button
    var isDeletable = $item.hasClass('deletable');
    if (isDeletable && $item.data('type') == 'folder') // only allow to delete empty userPl folders
    {
        if ($item.siblings('ul').children().length > 0) isDeletable = false;
    }
    $("#" + $list.attr('id') + "DeleteBtn").css('display', isDeletable ? 'inline' : 'none');
    if (!toggle) {
        $item.addClass("selected");
        if ($item.data('type') == "song") $joRjU.fetchSongInfo($item.data('id')).then(function(info) {
            if (info.pls !== undefined && !$.isEmptyObject(info.pls)) $joRjU.showPlaylists(info.pls);
        });
    } else $item.toggleClass("selected");
}
var $b7e1373c359c4425$export$98b7ee2ca8db699 = new $b7e1373c359c4425$var$ListWidget($('#songlist'), 'songlist');
var $b7e1373c359c4425$export$5c987fb934dae1e6 = new $b7e1373c359c4425$var$ListWidget($('#playlist'), 'playlist');

});
parcelRegister("kwZQV", function(module, exports) {

$parcel$export(module.exports, "Song", function () { return $c1026a215426858b$export$b2cb268b4d0123e0; });
$parcel$export(module.exports, "PlayerInstance", function () { return $c1026a215426858b$export$b0d1001d68a85430; });
$parcel$export(module.exports, "gotStatus", function () { return $c1026a215426858b$export$ac41d1df7e2c3dee; });
$parcel$export(module.exports, "clearPlaylist", function () { return $c1026a215426858b$export$3f38533be42eeb8b; });
$parcel$export(module.exports, "getId", function () { return $c1026a215426858b$export$218c8c3169c024d2; });
$parcel$export(module.exports, "drop", function () { return $c1026a215426858b$export$663103110d94aac9; });
$parcel$export(module.exports, "reactivateScheduler", function () { return $c1026a215426858b$export$b110d619d559cb77; });
$parcel$export(module.exports, "getNames", function () { return $c1026a215426858b$export$dc8de070e3f64a1a; });
$parcel$export(module.exports, "setCurrentPlayer", function () { return $c1026a215426858b$export$ac62f8f01a56147b; });
$parcel$export(module.exports, "prev", function () { return $c1026a215426858b$export$232faf9add678146; });
$parcel$export(module.exports, "playPause", function () { return $c1026a215426858b$export$896c3927874d3a3f; });
$parcel$export(module.exports, "next", function () { return $c1026a215426858b$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "seek", function () { return $c1026a215426858b$export$990806b8ad8af834; });
$parcel$export(module.exports, "toggleShuffle", function () { return $c1026a215426858b$export$858a1490762d88d9; });

var $9fkOq = parcelRequire("9fkOq");

var $7opof = parcelRequire("7opof");

var $ekiM6 = parcelRequire("ekiM6");

var $aKPTH = parcelRequire("aKPTH");

var $5GcKx = parcelRequire("5GcKx");

var $ccVOz = parcelRequire("ccVOz");

var $joRjU = parcelRequire("joRjU");

var $gl5tQ = parcelRequire("gl5tQ");

var $jM90n = parcelRequire("jM90n");
var $c1026a215426858b$var$_playerId = null;
var $c1026a215426858b$var$_currentPlayer = null;
var $c1026a215426858b$export$b2cb268b4d0123e0 = function Song() {
    "use strict";
    (0, $9fkOq._)(this, Song);
};
var $c1026a215426858b$var$Status = function Status() {
    "use strict";
    (0, $9fkOq._)(this, Status);
    this.state = 'error';
};
var $c1026a215426858b$export$b0d1001d68a85430 = /*#__PURE__*/ function() {
    "use strict";
    function PlayerInstance(playerId) {
        (0, $9fkOq._)(this, PlayerInstance);
        this.onStatus = $c1026a215426858b$export$ac41d1df7e2c3dee;
        this.playerId = playerId;
        this.pos = 0;
        this.state = new $c1026a215426858b$var$Status();
        this.ts = new Date();
        this.infoReq = null;
        this.infoTimer = null;
        this.checkTimer = null;
        this.reconnectTimer = null;
    }
    (0, $7opof._)(PlayerInstance, [
        {
            key: "close",
            value: function close() {
                if (this.infoReq) this.infoReq.close();
                if (this.infoTimer) clearInterval(this.infoTimer);
                if (this.checkTimer) clearInterval(this.checkTimer);
                if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
            }
        },
        {
            key: "connect",
            value: function connect() {
                var self = this;
                if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
                this.infoReq = new EventSource($ccVOz.applyBaseURL("/player/" + this.playerId + "/info.stream"), {
                    withCredentials: true
                });
                this.infoReq.onmessage = function(data) {
                    self._onInfo(data);
                };
                this.infoReq.onerror = function(error) {
                    console.error("EventStream error: ", error);
                    self.close();
                    $('body').addClass('connection-lost');
                    self.reconnectTimer = setTimeout(function() {
                        // 2022-09-14: we can't figure out the HTTP error code here, so let's instead
                        // also fire off a regular AJAX request (in case we get a 401/403 that'll trigger the login form to pop up)
                        $c1026a215426858b$var$_fetchInfo();
                        // can't use setCurrentPlayer() because it would reset the timers etc.
                        self.connect();
                    }, 5000);
                };
                this.checkTimer = setInterval(function() {
                    self._checkStream();
                }, 2000);
            }
        },
        {
            key: "_checkStream",
            value: function _checkStream() {
                // will run every two seconds in EventStream mode
                var now = new Date().getTime();
                if (this.ts.getTime() < now - 30000) // the last message we received is older than 30sec -> fall back to polling mode
                $c1026a215426858b$var$_fetchInfo();
            }
        },
        {
            key: "_onInfo",
            value: function _onInfo(msg) {
                var player = $c1026a215426858b$var$_currentPlayer;
                if (player == null) return;
                $('body').removeClass('connection-lost');
                var info = JSON.parse(msg.data);
                //console.log('got state: ', info);
                player.state = PlayerInstance._updateDict(player.state, info);
                player.ts = new Date();
                this.onStatus(new $aKPTH.Result(player.state));
            }
        }
    ], [
        {
            key: "_updateDict",
            value: function _updateDict(oldDict, newDict) {
                for(var k in newDict){
                    var oldValue = oldDict[k];
                    var newValue = newDict[k];
                    if (oldValue !== null && (typeof oldValue === "undefined" ? "undefined" : (0, $ekiM6._)(oldValue)) === 'object') newValue = PlayerInstance._updateDict(oldDict[k], newValue);
                    oldDict[k] = newValue;
                }
                return oldDict;
            }
        }
    ]);
    return PlayerInstance;
}();
function $c1026a215426858b$export$3f38533be42eeb8b() {
    $jM90n.playlist.showLoadingIndicator();
    $ccVOz.post("/player/" + $c1026a215426858b$export$218c8c3169c024d2() + "/playlist/clear").then(function(data) {
        $jM90n.playlist.loadData(data);
    });
}
function $c1026a215426858b$export$663103110d94aac9(ev) {
    var _ev_originalEvent;
    var dataTransfer = (_ev_originalEvent = ev.originalEvent) === null || _ev_originalEvent === void 0 ? void 0 : _ev_originalEvent.dataTransfer;
    if (dataTransfer === null || dataTransfer === undefined) {
        console.error("modPlayer.drop(): missing drag'n'drop data");
        return;
    }
    var data = JSON.parse(dataTransfer.getData($aKPTH.ERT_MIMETYPE));
    if (data.length != 1) throw "can only drop one entity at a time";
    data = data[0];
    $jM90n.playlist.showLoadingIndicator();
    $ccVOz.post('/player/' + $c1026a215426858b$var$_playerId + "/play", data).then(function(data) {
        $jM90n.playlist.loadData(data, true);
    });
}
function $c1026a215426858b$export$b110d619d559cb77() {
    $jM90n.playlist.showLoadingIndicator();
    $ccVOz.post('/player/' + $c1026a215426858b$var$_playerId + '/enableScheduler').then(function(data) {
        $('body').removeClass('schedulerDisabled');
        $jM90n.playlist.loadData(data, true);
    });
}
function $c1026a215426858b$export$218c8c3169c024d2() {
    return $c1026a215426858b$var$_playerId;
}
function $c1026a215426858b$export$dc8de070e3f64a1a() {
    var promise = $.Deferred();
    $aKPTH.getAppState().then(function(state) {
        promise.resolve(state.players);
    }, function(jqXHR, textStatus, errorThrown) {
        promise.reject(jqXHR, textStatus, errorThrown);
    });
    return promise;
}
function $c1026a215426858b$export$ac62f8f01a56147b(playerId) {
    playerId = parseInt(playerId.toString());
    $c1026a215426858b$var$_playerId = playerId;
    console.log("active player: ", playerId + 1);
    // close old request
    if ($c1026a215426858b$var$_currentPlayer != null) {
        $c1026a215426858b$var$_currentPlayer.close();
        $c1026a215426858b$var$_currentPlayer = null;
    }
    // create new one
    $c1026a215426858b$var$_currentPlayer = new $c1026a215426858b$export$b0d1001d68a85430(playerId);
    try {
        $c1026a215426858b$var$_currentPlayer.connect();
    } catch (e) {
        console.error("Missing EventStream support! Falling back to polling :(");
        $c1026a215426858b$var$_currentPlayer.infoTimer = setInterval($c1026a215426858b$var$_fetchInfo, 2000);
    }
    return $c1026a215426858b$var$_currentPlayer;
}
function $c1026a215426858b$var$_fetchInfo() {
    if ($c1026a215426858b$var$_currentPlayer == null) return; // no active player (yet)
    $ccVOz.request('player/' + $c1026a215426858b$var$_currentPlayer.playerId + '/info').then(function(data) {
        console.log('gotPlayerStatus: ', data);
        $c1026a215426858b$export$ac41d1df7e2c3dee(data);
    });
}
function $c1026a215426858b$export$ac41d1df7e2c3dee(data) {
    if (!data) return;
    var result = data.result;
    if (!result) return;
    var $playlist = $('#playlist');
    var title, artist, picture;
    if (result.song) {
        title = result.song.title;
        artist = result.song.artist;
        if (result.song.id != null && result.song.type != null) $playlist.trigger('songChanged', [
            result.song
        ]);
        else $playlist.trigger('songChanged', [
            null
        ]);
        if (result.song.picture) // TODO this isn't used anywhere
        picture = $ccVOz.applyBaseURL('/archive/picture?id=' + result.song.picture);
    }
    if (result.playlistHash !== undefined && result.playlistHash != $playlist.data('_hash')) {
        console.log("playlist changed, reloading...");
        $jM90n.playlist.showLoadingIndicator();
        $ccVOz.request('player/' + result.player + '/playlist').then(function(data) {
            $jM90n.playlist.loadData(data, true);
        });
        $playlist.data('_hash', result.playlistHash); // update it so we won't cause multiple AJAX requests
    }
    var $archive = $('#archive');
    if ($archive.length > 0 && result.archiveHash !== undefined && result.archiveHash != $archive.data('_hash')) {
        console.log("archive changed, reloading...");
        $joRjU.reloadWidget();
        $archive.data('_hash', result.archiveHash);
    }
    switch(result.state){
        case "playing":
        case "paused":
            break; // ignored
        case "stopped":
            title = "stopped";
            artist = "";
            break;
        case "error":
            title = "error";
            artist = "";
            break;
        default:
            console.error("unsupported player state: ", result.state);
    }
    if (title == undefined) title = '';
    if (artist == undefined) artist = '';
    $c1026a215426858b$var$_setText("#title", title);
    $c1026a215426858b$var$_setText("#artist", artist);
    var currentTime = 0, remainingTime = 0, totalTime = 0;
    if (result.time) {
        currentTime = result.time.current / 1000;
        remainingTime = result.time.remaining / 1000;
        totalTime = result.time.total / 1000;
        if (result.time.total <= 0) {
            remainingTime = -1;
            totalTime = -1;
        }
    }
    $('#currentTime').text($aKPTH.formatDuration(currentTime));
    $('#remainingTime').text($aKPTH.formatDuration(remainingTime));
    var seekBar = $5GcKx.ProgressBar('#timeProgress');
    seekBar.setMax(totalTime);
    seekBar.setValue(currentTime);
    var btn = $('#playPauseBtn');
    if (result.state == "playing") btn.removeClass('paused').addClass('playing');
    else btn.removeClass('playing').addClass('paused');
    if ("volume" in result) {
        var volume = result.volume;
        if (volume != undefined) $5GcKx.ProgressBar('#volume').setValue(volume);
    }
    if ("shuffle" in result) {
        if (result.shuffle) $('#shuffleBtn.shuffleOff').removeClass('shuffleOff').addClass('shuffleOn');
        else $('#shuffleBtn.shuffleOn').removeClass('shuffleOn').addClass('shuffleOff');
    }
    if ("schedulerDisabled" in result) {
        if (result.schedulerDisabled) $('body').addClass('schedulerDisabled');
        else $('body').removeClass('schedulerDisabled');
    }
    var $albumImg = $('.albumArt');
    if ($albumImg.length > 0) $gl5tQ.loadImage($albumImg, picture);
}
function $c1026a215426858b$var$_setText(selector, text) {
    var $elem = $(selector);
    if ($elem.hasClass('trackInfo')) $5GcKx.TrackInfo($elem).setText(text);
    else {
        var origWidth = $elem.width();
        if (origWidth == undefined) throw "wgt._setText(): missing origWidth";
        $elem.text(text);
        $elem.width(origWidth);
    }
}
function $c1026a215426858b$var$postCommand(cmd, data) {
    $ccVOz.request('player/' + $c1026a215426858b$export$218c8c3169c024d2() + '/' + cmd, data, {
        dataType: 'json',
        method: 'POST'
    }).then($c1026a215426858b$export$ac41d1df7e2c3dee);
}
function $c1026a215426858b$export$232faf9add678146() {
    $c1026a215426858b$var$postCommand('prev');
}
function $c1026a215426858b$export$896c3927874d3a3f() {
    $c1026a215426858b$var$postCommand('playPause');
}
function $c1026a215426858b$export$48cfd1e771a65c4f() {
    $c1026a215426858b$var$postCommand('next');
}
function $c1026a215426858b$export$990806b8ad8af834(msec) {
    $c1026a215426858b$var$postCommand('seek', {
        'msec': msec
    });
}
function $c1026a215426858b$export$858a1490762d88d9() {
    var data = {
        'shuffle': 'toggle'
    };
    $jM90n.playlist.showLoadingIndicator();
    $ccVOz.post("/player/" + $c1026a215426858b$export$218c8c3169c024d2() + "/playlist/shuffle", data).then(function(data) {
        $jM90n.playlist.loadData(data);
        //loadAppState();
        if ('shuffle' in data.result) {
            if (data.result.shuffle) $('#shuffleBtn').removeClass('shuffleOff').addClass('shuffleOn');
            else $('#shuffleBtn').removeClass('shuffleOn').addClass('shuffleOff');
        }
    });
}
$(function() {
    // for android: dis-/reconnect to the EventSource on app stop/resume
    window.addEventListener('appStop', function() {
        if ($c1026a215426858b$var$_currentPlayer != null) {
            console.log('app lost focus, closing EventSource');
            $c1026a215426858b$var$_currentPlayer.close();
            $c1026a215426858b$var$_currentPlayer = null;
        }
    });
    window.addEventListener('appResume', function() {
        console.log('app regained focus, resuming EventSource');
        if ($c1026a215426858b$var$_playerId !== null) $c1026a215426858b$export$ac62f8f01a56147b($c1026a215426858b$var$_playerId);
    });
});

});
parcelRegister("ekiM6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a6e17f4363c1f032$export$71511d61b312f219; });
function $a6e17f4363c1f032$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("5GcKx", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", function () { return $bcc5b33536d4c375$export$c17561cb55d4db30; });
$parcel$export(module.exports, "TrackInfo", function () { return $bcc5b33536d4c375$export$7872447382cf3226; });

var $9fkOq = parcelRequire("9fkOq");

var $7opof = parcelRequire("7opof");
var $bcc5b33536d4c375$var$ProgressBarWidget = /*#__PURE__*/ function() {
    "use strict";
    function ProgressBarWidget($elem) {
        (0, $9fkOq._)(this, ProgressBarWidget);
        this.$elem = $elem;
        this.value = 0;
        this.max = 0;
        $elem.addClass("progressBar");
        this.$bar = $('<div class="bar">');
        this.$progress = $('<div class="progress">');
        this.$handle = $('<div class="handle">');
        var $handleContainer = $('<div class="handleContainer">');
        $handleContainer.append(this.$handle);
        this.$bar.append(this.$progress);
        $handleContainer.append(this.$handle);
        $elem.append(this.$bar);
        $elem.append($handleContainer);
        $elem.data('_progressBar', this);
    }
    (0, $7opof._)(ProgressBarWidget, [
        {
            key: "_getSelf",
            value: function _getSelf() {
                return this.$elem.data('_progressBar');
            }
        },
        {
            key: "getMax",
            value: function getMax() {
                return this._getSelf().max;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this._getSelf().value;
            }
        },
        {
            key: "setMax",
            value: function setMax(maxValue) {
                this._update(undefined, maxValue);
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                this._update(value);
            }
        },
        {
            key: "_update",
            value: function _update(value, maxValue) {
                var self = this._getSelf();
                var percent = -1;
                if (self === undefined) return;
                if (value !== undefined) self.value = value;
                if (maxValue !== undefined) self.max = maxValue;
                var progress = self.value / self.max * 100;
                if (self.max > 0) percent = Math.floor(progress);
                if (percent >= 0) {
                    self.$progress.css('width', progress + "%");
                    self.$handle.css('left', progress + '%');
                    self.$elem.removeClass('noDuration');
                } else self.$elem.addClass('noDuration');
            }
        }
    ]);
    return ProgressBarWidget;
}();
function $bcc5b33536d4c375$export$c17561cb55d4db30(selector) {
    // return existing ProgressBarWidget if it exists
    var $elem = $(selector);
    var rc = $elem.data('_progressBar');
    if (rc) return rc;
    return new $bcc5b33536d4c375$var$ProgressBarWidget($elem);
}
var $bcc5b33536d4c375$var$TrackInfoWidget = /*#__PURE__*/ function() {
    "use strict";
    function TrackInfoWidget($elem) {
        (0, $9fkOq._)(this, TrackInfoWidget);
        this.$elem = $elem;
        $elem.addClass("trackInfo");
        this.currentPos = -10;
        this.currentStep = -2;
        this.$subElem = $('<div class="trackText">');
        $elem.append(this.$subElem);
        $elem.data('_trackInfo', this);
    }
    (0, $7opof._)(TrackInfoWidget, [
        {
            key: "setText",
            value: function setText(text) {
                this.$subElem.text(text);
                this._sizeChanged();
            }
        },
        {
            key: "_getContentWidth",
            value: function _getContentWidth() {
                var rc = this.$subElem.width();
                if (rc == undefined) throw "TrackInfo: missing content width";
                return rc;
            }
        },
        {
            key: "_getViewportWidth",
            value: function _getViewportWidth() {
                var rc = this.$elem.width();
                if (rc == undefined) throw "TrackInfo: missing viewport width";
                return rc;
            }
        },
        {
            key: "_move",
            value: function _move() {
                this.currentPos += this.currentStep;
                var pos = this.currentPos;
                var minPos = this._getViewportWidth() - this._getContentWidth();
                // check whether we need to revert our direction
                if (this.currentStep < 0) // currently moving left
                {
                    if (pos < minPos - 30) // revert direction
                    this.currentStep *= -1;
                } else // currently moving right
                if (pos >= 30) // revert direction
                this.currentStep *= -1;
                // this causes the div to stop instead of overshooting
                if (pos < minPos) pos = minPos;
                if (pos > 0) pos = 0;
                this._moveToPos(pos);
            }
        },
        {
            key: "_moveToPos",
            value: function _moveToPos(pos) {
                this.$elem.scrollLeft(-1 * pos);
            }
        },
        {
            key: "_sizeChanged",
            value: function _sizeChanged() {
                if (this.interval != undefined) clearInterval(this.interval);
                if (this._getViewportWidth() < this._getContentWidth()) {
                    // we're too small => scroll
                    if (!this.currentPos) this.currentPos = 0;
                    if (!this.currentStep) this.currentStep = -2;
                    var self = this;
                    this.interval = setInterval(function() {
                        self._move();
                    }, 40);
                } else // enough size => just display it at pos 0,0
                this.currentPos = 0;
                this._moveToPos(this.currentPos);
            }
        }
    ]);
    return TrackInfoWidget;
}();
function $bcc5b33536d4c375$export$7872447382cf3226(selector) {
    var $elem = $(selector);
    var rc = $elem.data("_trackInfo");
    if (rc) return rc;
    // set up container (for all matching elements)
    $elem.each(function(_i, elem) {
        var $elem = $(elem);
        new $bcc5b33536d4c375$var$TrackInfoWidget($elem);
    });
    return $elem.data('_trackInfo'); // returns the first matching object
}

});

parcelRegister("gl5tQ", function(module, exports) {

$parcel$export(module.exports, "loadImage", function () { return $f38b91dcbbb972cc$export$fe58198efe02b173; });
/* loads an image lazily (and displays it once it's been fully loaded)
- selector is expected to be a <div> element. if you add an <img class="notFoundImage"> image, that one will be loaded on error
*/ function $f38b91dcbbb972cc$export$fe58198efe02b173($div, url) {
    if ($div.length == 0) return;
    if ($div.data('_imgUrl') === url) return; // URL hasn't changed
    $f38b91dcbbb972cc$var$initContainer($div);
    if (url == null || url == '') $f38b91dcbbb972cc$export$117f7ddab482d006($div);
    var $img = $('<img>');
    $img.attr('src', url);
    $img.on('error', function(a, b, c) {
        $f38b91dcbbb972cc$export$117f7ddab482d006($div);
        console.log('image error: ', a, b, c);
    }).on('load', function(a, b, c) {
        $div.empty().append($img.show());
        console.log('image loaded: ', a, b, c);
    });
    $div.data('_imgUrl', url);
    $div.append($img.hide());
}
function $f38b91dcbbb972cc$export$117f7ddab482d006($div) {
    var $notFoundImage = $div.data('_notFoundImage');
    $div.empty();
    if ($notFoundImage == undefined) return; // there isn't one
    $div.append($notFoundImage);
}
// initialize the container <div>
function $f38b91dcbbb972cc$var$initContainer($div) {
    if ($div.data("_notFoundImage") !== undefined) return; // already initialized
    var $notFoundImage = $('img.notFoundImage', $div);
    if ($notFoundImage.length == 0) {
        $div.data("_notFoundImage", null);
        return;
    }
    // remove the element from the DOM, but keep it in memory
    $div.data("_notFoundImage", $notFoundImage);
    console.log('image container initialized');
}

});



parcelRegister("g9BBR", function(module, exports) {

$parcel$export(module.exports, "detectLanguage", function () { return $3d432634ae3530c3$export$ae9ea24a1b29b07c; });
$parcel$export(module.exports, "set", function () { return $3d432634ae3530c3$export$adaa4cf7ef1b65be; });

var $4yxFB = parcelRequire("4yxFB");

var $gIwmW = parcelRequire("gIwmW");
var $3d432634ae3530c3$var$_locales = {
    'en': {
        '_lang': 'en'
    },
    'de': $3d432634ae3530c3$var$flattenRec((0, (/*@__PURE__*/$parcel$interopDefault($4yxFB)))),
    'it': $3d432634ae3530c3$var$flattenRec((0, (/*@__PURE__*/$parcel$interopDefault($gIwmW))))
};
var $3d432634ae3530c3$var$_active;
// _applyLocale -- finds DOM nodes with 'data-tr' and applies the given language to them
// TODO this only works for $(...).text(), add support for other attributes (like placeholder, ...)
function $3d432634ae3530c3$var$_apply(lang, $rootElement) {
    if (!$3d432634ae3530c3$var$_locales || !$3d432634ae3530c3$var$_locales[lang]) {
        console.error("tried to apply locale that hasn't been loaded yet");
        return;
    }
    $3d432634ae3530c3$var$_active = lang;
    $('[data-tr]', $rootElement).each(function(_n, elem) {
        var key = elem.dataset['tr'];
        if (key == undefined) return;
        var locale = $3d432634ae3530c3$var$_locales[lang];
        if (key in locale) {
            var $elem = $(elem);
            if (!(key in $3d432634ae3530c3$var$_locales['en'])) $3d432634ae3530c3$var$_locales['en'][key] = $elem.text();
            $elem.text(locale[key]);
        } else if (locale._lang !== 'en') {
            if (window.console) console.error('i18n failed for key ', elem.dataset['tr'], elem);
        }
    });
}
function $3d432634ae3530c3$export$ae9ea24a1b29b07c() {
    var rc = null;
    for(var i in navigator.languages){
        var code = navigator.languages[i].toLowerCase().replace('_', '-').split('-')[0]; // we only care about the first part (e.g. 'en' for 'en_US' or 'en-US')
        if (code in $3d432634ae3530c3$var$_locales) {
            rc = code;
            break;
        }
    }
    if (rc != null) console.log("detected language: ", rc);
    else {
        console.log("no matching language found, defaulting to English");
        rc = 'en';
    }
    return rc;
}
function $3d432634ae3530c3$export$adaa4cf7ef1b65be(lang, $rootElement) {
    if (lang == undefined) lang = $3d432634ae3530c3$var$_active;
    if (lang == undefined) lang = $3d432634ae3530c3$export$ae9ea24a1b29b07c();
    $3d432634ae3530c3$var$_active = lang;
    $3d432634ae3530c3$var$_apply(lang, $rootElement);
}
function $3d432634ae3530c3$var$flattenRec(data) {
    var result = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, path = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    for(var key in data){
        var value = data[key];
        var childPath = path.concat([
            key
        ]);
        if (value.constructor == Object) $3d432634ae3530c3$var$flattenRec(value, result, childPath);
        else if ($.isArray(value)) $3d432634ae3530c3$var$flattenRec(value, result, childPath);
        else result[childPath.join('.')] = value;
    }
    return result;
}

});
parcelRegister("4yxFB", function(module, exports) {
module.exports = JSON.parse('{"_lang":"de","archive":{"playlists":"Eartunes","userPlaylists":"Eigene Eartunes","radio":"Eartunes Radio","archive":"Musik-Archiv"},"btn":{"save":"Speichern","delete":"L\xf6schen","mkdir":"Neuer Ordner","ok":"Ok","cancel":"Abbrechen"},"deletePl":{"title":"Playliste l\xf6schen","prompt":"Wollen Sie die Playliste wirklich l\xf6schen:"},"deleteFolder":{"title":"Ordner l\xf6schen","prompt":"Wollen Sie den Ordner wirklich l\xf6schen:"},"list":{"archive":"Archiv","artist":"Interpret","title":"Titel","duration":"Dauer"},"login":{"title":"Login","user":"Benutzer:","password":"Passwort:","btn":"Login","error":"Benutzer/Passwort falsch"},"mkdir":{"title":"Ordner erstellen","prompt":"Geben Sie einen Namen f\xfcr den neuen Ordner ein"},"savePlaylist":{"title":"Playliste speichern","prompt":"Bitte w\xe4hlen Sie einen Namen und Speicherort f\xfcr die Playliste"},"scheduler":{"edit":"Bearbeiten","any":"Beliebig","all":"Alle","none":"Keine","add":"Neu","delete":"L\xf6schen","enabled":"Aktiv","weekdays":"Wochentage","startTime":"Startzeit","endTime":"Endzeit","pls":"Playlisten","frequency":"Intervall","startDate":"Startdatum","endDate":"Enddatum","yearly":"J\xe4hrlich","mode":"Modus","players":"Player","jingles":"Jingles","volume":"Lautst\xe4rke","keepVolume":"Unver\xe4ndert","days":["Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag","Sonntag"],"intervalPrompt":"deaktiviert den Eintrag","editTitle":{"_":"Scheduler bearbeiten","date":"Datum bearbeiten","jingles":"Jingles bearbeiten","interval":"Intervall bearbeiten","mode":"Modus bearbeiten","players":"Player bearbeiten","playlists":"Playlisten bearbeiten","time":"Zeit bearbeiten","volume":"Lautst\xe4rke bearbeiten","weekdays":"Wochentage bearbeiten"},"modes":{"playOne":"Eines spielen","playInOrder":"Sortiert spielen","playNow":"Sofort spielen","disabled":"Deaktiviert"}},"settings":{"editSoundcard":"Soundkarte bearbeiten"},"conn":{"loading":"l\xe4dt...","lost":"Verbindung verloren","reconnecting":"verbindungsaufbau..."},"users":{"title":"Web-Benutzer","new":"Neuer Benutzer","delete":"L\xf6schen","name":"Benutzer","pwd":"Passwort","pwdConfirm":"Best\xe4tigen","group":"Gruppe","players":"Player","btnCreate":"Erstellen","plDir":{"_":"Playlist-Ordner","title":"Playlist-Ordner ausw\xe4hlen","prompt":"Der neue Benutzer sieht nur den gew\xe4hlten Ordner"}}}');

});

parcelRegister("gIwmW", function(module, exports) {
module.exports = JSON.parse('{"_lang":"it","archive":{"playlists":"Eartunes","userPlaylists":"Le mie playlist","radio":"Eartunes Radio","archive":"Music Archive"},"btn":{"save":"Salva","delete":"Cancella","mkdir":"Nuova cartella","ok":"Ok","cancel":"Annulla"},"deletePl":{"title":"Cancella playlist","prompt":"Vuoi veramente cancellare la playlist:"},"deleteFolder":{"title":"Cancella cartella","prompt":"Vuoi veramente cancellare la cartella:"},"list":{"archive":"Archivio","artist":"Artista","title":"Titolo","duration":"Lunghezza"},"~login":{"title":"Login","user":"User:","password":"Password:","btn":"Login","error":"Login failed"},"mkdir":{"title":"Nuova cartella","prompt":"Inserisci un nuovo nome per la cartella"},"savePlaylist":{"title":"Salva playlist","prompt":"Inserisci un nuovo nome per la playlist"},"scheduler":{"~edit":"Edit","any":"Ogni","all":"Tutti","none":"Nessuno","add":"Nuovo","delete":"Cancella","enabled":"Abilitato","weekdays":"Giorni della settimana","startTime":"Orario","endTime":"Fine","pls":"Playlist","frequency":"Frequenza","startDate":"Data inizio","endDate":"Data fine","mode":"Modalit\xe0","players":"Player","jingles":"Jingles","volume":"Volume","keepVolume":"Mantieni","days":["Luned\xec","Marted\xec","Mercoled\xec","Gioved\xec","Venerd\xec","Sabato","Domenica"],"~editTitle":{"_":"edit scheduler","date":"edit date","jingles":"edit jingles","interval":"edit interval","mode":"edit mode","players":"edit players","playlists":"edit playlists","time":"edit time","volume":"edit volume","weekdays":"edit week days"},"modes":{"playOne":"Suona uno","playInOrder":"Suona in ordine","playNow":"Suona subito","disabled":"Disabilita"}},"settings":{"~editSoundcard":"edit sound card"},"~conn":{"lost":"connection lost","reconnecting":"connecting..."},"~users":{"title":"Web Users","new":"New User","delete":"Cancella","name":"Nome","pwd":"Password","pwdConfirm":"Confirm","group":"Group","players":"Player","btnCreate":"Create","plDir":{"_":"Playlist Folder","title":"Select Playlist Folder","prompt":"The new user will only see playlists inside of the selected directory"}}}');

});




})();
//# sourceMappingURL=index.6ab435ac.js.map
